<div class="card flex-grow mb-0 product-creation-wizard" style="margin: 0 15px 15px; background-color: transparent">
  <div class="content-area-wrapper" style="height: 87vh; gap: 16px; justify-content: center">
    <div class="card content-right custom-scroll mx-auto" style="overflow: auto; max-width: 720px; width: 100%">
      <div class="card-body wizard-content p-4">
        <h4 class="mb-2">Connexion logiciel caisse</h4>
        <p class="text-muted mb-3">
          Saisissez le mot de passe de l’accès logiciel caisse pour la station
          <strong>{{ code_station }}</strong>.
        </p>
        <div class="form-section rounded p-3">
          <div class="mb-2">
            <label class="form-label">Email</label>
            <input class="form-control" type="email" [(ngModel)]="email" readonly />
          </div>
          <div class="mb-0">
            <label class="form-label">Mot de passe</label>
            <input class="form-control" type="password" [(ngModel)]="password" />
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3 gap-2">
          <button type="button" class="btn btn-outline-secondary" (click)="retour()" [disabled]="isSubmitting">
            Retour
          </button>
          <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="isSubmitting">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
            Se connecter
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
